"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LabeledIcon = function LabeledIcon(_ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      info = _ref.info,
      feature = _ref.feature,
      warning = _ref.warning,
      success = _ref.success,
      danger = _ref.danger,
      fontSmall = _ref.fontSmall,
      iconProps = _objectWithoutProperties(_ref, ["label", "disabled", "info", "feature", "warning", "success", "danger", "fontSmall"]);

  var allowedModifiers = {
    disabled: disabled,
    info: info,
    feature: feature,
    warning: warning,
    success: success,
    danger: danger,
    fontSmall: fontSmall
  };
  return _react.default.createElement(_styler.default, {
    classNames: ['co-label-icon'],
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("span", {
      className: styles,
      disabled: disabled
    }, _react.default.createElement(_icon.default, iconProps), label);
  });
};

var mutuallyExclusiveVariations = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('success', 'info', 'warning', 'danger', 'feature');
LabeledIcon.propTypes = {
  label: _propTypes.string.isRequired,
  success: mutuallyExclusiveVariations,
  info: mutuallyExclusiveVariations,
  warning: mutuallyExclusiveVariations,
  danger: mutuallyExclusiveVariations,
  feature: mutuallyExclusiveVariations,
  fontSmall: _propTypes.bool
};
var _default = LabeledIcon;
exports.default = _default;
LabeledIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LabeledIcon",
  "props": {
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveVariations"
      },
      "required": false,
      "description": ""
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveVariations"
      },
      "required": false,
      "description": ""
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveVariations"
      },
      "required": false,
      "description": ""
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveVariations"
      },
      "required": false,
      "description": ""
    },
    "feature": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveVariations"
      },
      "required": false,
      "description": ""
    },
    "fontSmall": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};